import type { JSX } from 'react';
export default function SmallCard({
  title,
  description,
  component,
}: {
  title: string;
  description: string;
  component?: JSX.Element;
}) {
  return (
    <div
      className='break-word tablet:min-w-70 relative flex flex-col rounded-xl border border-black/10 bg-white p-8
        pb-10'
    >
      <div className='font-display text-xl'>{title}</div>
      <p className='break-word mt-2 text-base text-gray-700'>{description}</p>
      {component && <div className='mt-4'>{component}</div>}
    </div>
  );
}
